import { Button, Card, Form, Input, Radio } from "antd";
import { useNavigate } from "react-router";
import { useRequestOtpMutation } from "../../../app/features/auth/auth.api";
import Banner from "../../../assets/images/loginBanner.svg";
import Logo from "../../../assets/images/Logo.svg";
import Seo from "../../../components/common/Seo";
import { errorToast } from "../../../utils/error.utils";
import { normalizePhoneNumber } from "../../../utils/string.utils";
import RightIcon from "../../web/allCourses/_icons/RightIcon";

export default function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const loginMethod = Form.useWatch("loginMethod", form);

  const [requestOtp, { isLoading }] = useRequestOtpMutation();

  const handleSubmit = async (values: any) => {
    try {
      const isPhone = values.loginMethod === "phone";
      const payload: any = {
        otpChannel: values.loginMethod,
      };

      if (isPhone) {
        payload.phone = normalizePhoneNumber(values.phone);
      } else {
        payload.email = values.email;
      }

      await requestOtp(payload).unwrap();
      navigate("/otp", {
        state: {
          email: payload.email,
          phone: payload.phone,
          otpChannel: payload.otpChannel,
        },
      });
    } catch (error) {
      errorToast(error, "OTP পাঠান যায়নি");
    }
  };

  return (
    <div className="flex h-screen flex-col md:flex-row">
      <Seo title="Login - manPowerX" />
      {/* Left side - Banner */}
      <div className="hidden lg:block w-1/2 ">
        <img src={Banner} alt="Banner" className="w-full h-full object-cover" />
      </div>

      {/* Right side - Login card */}
      <div className="w-full lg:w-1/2 relative bg-[#E9F2F2] flex items-center justify-center h-screen md:h-auto">
        {/* Top-left Back button */}
        <div className="absolute top-4 left-4">
          <Button
            type="primary"
            size="middle"
            className="!bg-transparent !border-none !text-[#030D0D] text-lg font-medium"
            onClick={() => navigate("/")}
          >
            <RightIcon className="!text-[#030D0D] text-lg pb-1" /> হোমে ফিরে যান
          </Button>
        </div>

        {/* Centered Card */}
        <Card className="!w-96 shadow-xl sm:w-11/12" bordered={false}>
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={Logo} alt="Logo" className="h-14 w-auto" />
          </div>

          <div className="text-theme-zinc-700 text-xl font-semibold mb-6">
            লগইন করুন
          </div>

          {/* Login Form */}
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{ loginMethod: "email" }}
          >
            <Form.Item name="loginMethod" className="mb-6">
              <Radio.Group className="w-full grid grid-cols-2 text-center">
                <Radio.Button value="email" className="w-full text-center">
                  ইমেইল
                </Radio.Button>
                <Radio.Button value="phone" className="w-full text-center">
                  মোবাইল নম্বর
                </Radio.Button>
              </Radio.Group>
            </Form.Item>

            {loginMethod === "phone" ? (
              <Form.Item
                label="মোবাইল নম্বর"
                name="phone"
                validateFirst
                rules={[
                  { required: true, message: "মোবাইল নম্বর দিতে হবে!" },
                  {
                    pattern: /^(?:\+880|880|0)1[3-9]\d{8}$/,
                    message: "বৈধ বাংলাদেশি মোবাইল নম্বর দিন",
                  },
                ]}
              >
                <Input
                  placeholder="আপনার মোবাইল নম্বর দিন"
                  size="large"
                  className="antd-input-primary"
                />
              </Form.Item>
            ) : (
              <Form.Item
                label="ইমেইল"
                name="email"
                rules={[{ required: true, message: "ইমেইল দিতে হবে!" }]}
              >
                <Input
                  placeholder="name@example.com"
                  size="large"
                  className="antd-input-primary"
                />
              </Form.Item>
            )}

            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              className="pt-2"
              loading={isLoading}
            >
              OTP পাঠান
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
}
